import { useState, useCallback, useRef } from "react";
import SweetAlert from "@components/Feedback/SweetAlert/Index";
import { GetAllSolicitacoesByUnidadeWithRequiredFilter } from "@services/Solicitacao/Index";

export const useFetchSolicitacoesByUnidade = () => {
  const [solicitacaoLoading, setLoading] = useState(false);
  const [solicitacaoOptions, setOptions] = useState([]);
  const [totalItens, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const abortControllerRef = useRef(null);

  const fetchSolicitacoes = useCallback(async (idUnidadeGerencia, page = 1, perPage = 10) => {
    if (!idUnidadeGerencia) {
      setOptions([]);
      setTotal(0);
      return;
    }

    setLoading(true);

    try {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      abortControllerRef.current = new AbortController();

      const response = await GetAllSolicitacoesByUnidadeWithRequiredFilter(page, perPage, idUnidadeGerencia);

      if (!response) throw new Error("Sem resposta da API");

      const { items, totalItems, pageNumber, pageSize } = response;

      setOptions(
        items.map(s => ({
          value: s.id,
          label: s.numeroSolicitacao
        }))
      );
      setTotal(totalItems);
      setCurrentPage(pageNumber);
      setRowsPerPage(pageSize);
    } catch (error) {
      if (error.name !== 'AbortError') {
        SweetAlert.error("Erro ao buscar solicitações", String(error));
        setOptions([]);
        setTotal(0);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    solicitacaoOptions,
    solicitacaoLoading,
    fetchSolicitacoes,
    totalItens,
    currentPage,
    rowsPerPage,
    setCurrentPage,
    setRowsPerPage
  };
};
